import { Meteor } from 'meteor/meteor'

import React, { lazy } from 'react'
import { getProfileRegistar, logout, mailto } from './fonction'
import ListInvoices from './screens/backoffice/ListInvoices'
import { REGISTRATION_TYPE } from './components/LoginOrSignup'
import MyPaymentMethod from './screens/MyPaymentMethod'
import ProfileSubAccount from './screens/ProfileSubAccount'

const NewForgotPassword = lazy(() => import('./screens/NewForgotPassword'))
const NewResetPassword = lazy(() => import('./screens/NewResetPassword'))

const Home = lazy(() => import('./screens/Home'))
const ProfileLawyer = lazy(() => import('./screens/ProfileLawyer'))
const Profile = lazy(() => import('./screens/Profile'))
const ProfilePro = lazy(() => import('./screens/ProfilePro'))
const MyExpertise1 = lazy(() => import('./screens/MyExpertise1'))
const Availability = lazy(() => import('./screens/Availability'))
const ProfileLawyer1 = lazy(() => import('./screens/ProfileLawyer1'))
const ProfileLawyer2 = lazy(() => import('./screens/ProfileLawyer2'))
const ProfileLawyer3 = lazy(() => import('./screens/ProfileLawyer3'))
const MySubAccount = lazy(() => import('./screens/MySubAccount'))
const ChooseOffers = lazy(() => import('./screens/ChooseOffers'))
const MyCalls = lazy(() => import('./screens/MyCalls'))
const MyInvoices = lazy(() => import('./screens/MyInvoices'))
const History = lazy(() => import('./screens/History'))
const Partners = lazy(() => import('./screens/Partners'))
const Faqs = lazy(() => import('./screens/Faqs'))
const Calls = lazy(() => import('./screens/backoffice/Calls'))
const Categories = lazy(() => import('./screens/backoffice/Categories'))
const Customers = lazy(() => import('./screens/backoffice/users/Customers'))
const KeywordNotFound = lazy(() => import('./screens/backoffice/KeywordNotFound'))
const Mails = lazy(() => import('./screens/backoffice/Mails'))
const Barreaux = lazy(() => import('./screens/backoffice/Barreaux'))
const Languages = lazy(() => import('./screens/backoffice/Languages'))
const CustomerTypes = lazy(() => import('./screens/backoffice/CustomerTypes'))
const Competences = lazy(() => import('./screens/backoffice/Competences'))

const PaymentSelector = lazy(() => import('./screens/PaymentSelector'))
const CallQuestions = lazy(() => import('./screens/CallQuestions'))
const CallStatus = lazy(() => import('./screens/CallStatus'))
const ResultsLawyer = lazy(() => import('./screens/ResultsLawyer'))
const LawyerToCall = lazy(() => import('./screens/LawyerToCall'))
const Note = lazy(() => import('./screens/Note'))
const NoteLawyer = lazy(() => import('./screens/NoteLawyer'))
const AdminFaq = lazy(() => import('./screens/backoffice/AdminFaq'))
const AdminPartner = lazy(() => import('./screens/backoffice/AdminPartner'))
const Settings = lazy(() => import('./screens/backoffice/Settings'))
const Suggestions = lazy(() => import('./screens/backoffice/Suggestions'))
const CallPartner = lazy(() => import('./screens/backoffice/CallPartner'))

/**
 * INSCRIPTION
 */
const NewLogin = lazy(() => import('./screens/NewLogin'))
const NewSignup = lazy(() => import('./screens/NewSignup'))
const NewSignupLawyer = lazy(() => import('./screens/NewSignupLawyer'))
const Privacy = lazy(() => import('./screens/Privacy'))
const RegisterProfile = lazy(() => import('./screens/RegisterProfile'))
const RegisterProfileCategory = lazy(() => import('./screens/RegisterProfileCategory'))
const RegisterProfilePro = lazy(() => import('./screens/RegisterProfilePro'))
const RegisterProfileLawyer = lazy(() => import('./screens/RegisterProfileLawyer'))
const RegisterProfileLawyerUploadCard = lazy(() =>
  import('./screens/RegisterProfileLawyerUploadCard')
)
const RegisterLawyerProfileSchedule = lazy(() => import('./screens/RegisterLawyerProfileSchedule'))
const RegisterLawyerUploadPicture = lazy(() => import('./screens/RegisterLawyerUploadPicture'))
const RegisterProfileLawyerCustomers = lazy(() =>
  import('./screens/RegisterProfileLawyerCustomers')
)
const RegisterProfileLawyerPrice = lazy(() => import('./screens/RegisterProfileLawyerPrice'))
const RegisterLawyerAddress = lazy(() => import('./screens/RegisterLawyerAddress'))
const RegisterProfileLawyerPromise = lazy(() => import('./screens/RegisterProfileLawyerPromise'))
const RegisterLawyerAdditionalData = lazy(() => import('./screens/RegisterLawyerAdditionalData'))
const RegisterProfileLawyerSkills = lazy(() => import('./screens/RegisterProfileLawyerSkills'))

/**
 * CALL PROCESS
 */
const CallStepper = lazy(() => import('./components/CallStepper'))

const getRoutes = () => {
  const loggedIn = () => !!Meteor.userId()
  const isLawyer = () => Meteor.user()?.profile?.type === REGISTRATION_TYPE.LAWYER
  const isAdmin = () => !!Meteor.user()?.profile?.admin
  const isRegisterPending = getProfileRegistar()

  return [
    {
      title: 'SignupLawyer',
      titlePage: 'Signup Lawyer',
      path: '/signup-lawyer',
      component: NewSignupLawyer,
      condition: () => !loggedIn(),
      redirect: '/',
      routeType: 'signup-lawyer',
      registar: true,
    },
    {
      title: 'Signup',
      titlePage: 'Signup',
      path: '/signup',
      component: NewSignup,
      condition: () => !loggedIn(),
      redirect: '/',
      routeType: 'signup',
      registar: true,
    },
    {
      title: 'RegisterProfile',
      titlePage: 'Register Signup',
      path: '/register-profile',
      component: RegisterProfile,
      condition: () => !loggedIn(),
      redirect: '/',
      routeType: 'register-profile',
      registar: true,
    },
    {
      title: 'RegisterProfileLawyer',
      titlePage: 'RegisterProfileLawyer',
      path: '/register-profile-lawyer',
      component: RegisterProfileLawyer,
      condition: () => loggedIn() && isLawyer(),
      redirect: '/',
      routeType: 'register-profile-lawyer',
      registar: true,
      onlyFor: ['lawyer'],
    },
    {
      title: 'RegisterProfile',
      titlePage: 'Register Signup',
      path: '/register-profile-lawyer-price',
      component: RegisterProfileLawyerPrice,
      condition: () => loggedIn() && isLawyer(),
      redirect: '/',
      routeType: 'register-profile-lawyer-price',
    },
    {
      title: 'RegisterProfileCategory',
      titlePage: 'Register Profile Category',
      path: '/register-profile-category',
      component: RegisterProfileCategory,
      condition: loggedIn,
      redirect: '/',
      routeType: 'register-profile-category',
      registar: true,
      onlyFor: ['customer', 'pro'],
    },
    {
      title: 'RegisterProfilePro',
      titlePage: 'RegisterProfilePro',
      path: '/register-profile-pro',
      component: RegisterProfilePro,
      condition: loggedIn,
      redirect: '/',
      routeType: 'register-profile-pro',
      registar: true,
      onlyFor: ['pro', 'proCallIllimite', 'proChildren'],
    },
    {
      title: 'RegisterLawyerAddress',
      titlePage: 'RegisterLawyerAddress',
      path: '/register-lawyer-address',
      component: RegisterLawyerAddress,
      condition: () => loggedIn() && isLawyer(),
      redirect: '/',
      routeType: 'register-lawyer-address',
      registar: true,
      onlyFor: ['lawyer'],
    },
    {
      title: 'RegisterProfileLawyerCustomers',
      titlePage: 'RegisterProfileLawyerCustomers',
      path: '/register-profile-lawyer-customers',
      component: RegisterProfileLawyerCustomers,
      condition: loggedIn,
      redirect: '/',
      routeType: 'register-profile-lawyer-customers',
      registar: true,
      onlyFor: ['lawyer'],
    },
    {
      title: 'RegisterProfileLawyerPromise',
      titlePage: 'RegisterProfileLawyerPromise',
      path: '/register-profile-lawyer-promise',
      component: RegisterProfileLawyerPromise,
      condition: () => loggedIn() && isLawyer(),
      redirect: '/',
      routeType: 'register-profile-lawyer-promise',
    },
    {
      title: 'Login',
      titlePage: 'New Login',
      path: '/login',
      component: NewLogin,
      condition: () => !loggedIn(),
      redirect: '/',
      routeType: 'login',
    },
    {
      title: 'Register Profile Lawyer Card',
      titlePage: 'Register profile upload lawyer card',
      path: '/register-profile-lawyer-card',
      component: RegisterProfileLawyerUploadCard,
      condition: loggedIn,
      redirect: '/',
      routeType: 'register-profile-lawyer-card',
      registar: true,
      onlyFor: ['lawyer'],
    },
    {
      title: 'Register Profile Lawyer Skills',
      titlePage: 'RegisterProfileLawyerSkills',
      path: '/register-profile-lawyer-skills',
      component: RegisterProfileLawyerSkills,
      condition: () => loggedIn() && isLawyer(),
      redirect: '/',
      routeType: 'register-profile-lawyer-skills',
      registar: true,
      onlyFor: ['lawyer'],
    },
    {
      title: 'Register Lawyer Upload Picture',
      titlePage: 'Register Lawyer Upload Picture',
      path: '/register-lawyer-upload-picture',
      component: RegisterLawyerUploadPicture,
      condition: () => loggedIn() && isLawyer(),
      redirect: '/',
      routeType: 'register-lawyer-upload-picture',
      registar: true,
      onlyFor: ['lawyer'],
    },
    {
      title: 'Register Lawyer Additional Data',
      path: '/register-lawyer-additional-data',
      component: RegisterLawyerAdditionalData,
      condition: () => loggedIn() && isLawyer(),
      redirect: '/',
      routeType: 'register-lawyer-additional-data',
      registar: true,
      onlyFor: ['lawyer'],
    },
    {
      title: 'Register Lawyer Profile Schedule',
      titlePage: 'Register Lawyer Profile Schedule',
      path: '/register-lawyer-profile-schedule',
      component: RegisterLawyerProfileSchedule,
      condition: () => loggedIn() && isLawyer(),
      redirect: '/',
      routeType: 'register-lawyer-profile-schedule',
      registar: true,
      onlyFor: ['lawyer'],
    },
    {
      title: 'Privacy',
      titlePage: 'Connexion',
      path: '/privacy',
      component: Privacy,
      condition: () => !loggedIn(),
      redirect: '/',
      registar: true,
    },
    {
      title: 'ForgottenPassword',
      titlePage: 'Mot de passe oublié',
      path: '/forgot-password',
      component: NewForgotPassword,
      condition: () => !loggedIn(),
      redirect: '/',
    },
    {
      title: 'ResetPassword',
      titlePage: 'Réinitialisation du mot de passe',
      path: '/reset-password/:token',
      component: NewResetPassword,
      condition: () => !loggedIn(),
      redirect: '/',
    },
    {
      title: 'Home',
      path: '/',
      component: Home,
    },
    {
      title: 'result-lawyer',
      path: '/result-lawyer/:page?',
      component: ResultsLawyer,
    },
    {
      title: 'result-lawyer-select',
      path: '/lawyer/:lawyerId',
      component: LawyerToCall,
    },

    {
      title: 'ACCUEILWebApp',
      titlePage: 'Accueil',
      path: '/home-lawyer',
      component: ProfileLawyer,
      condition: loggedIn,
      onlyFor: ['lawyer'],
      typeRoute: 'profile',
    },
    {
      title: 'MONCOMPTE',
      titlePage: 'Mon profil PRO',
      path: '/profilepro',
      component: ProfilePro,
      condition: loggedIn,
      onlyFor: ['pro', 'proCallIllimite'],
      typeRoute: 'profile',
    },
    {
      title: 'MESINFOS',
      titlePage: 'Mon profil',
      path: '/profile',
      component: Profile,
      condition: loggedIn,
      onlyFor: ['pro', 'proCallIllimite'],
      subMenu: ['MONCOMPTE'],
      typeRoute: 'profile',
    },
    {
      title: 'MESINFOS',
      titlePage: 'Mon profil',
      path: '/profile-sub-account',
      component: ProfileSubAccount,
      condition: loggedIn,
      onlyFor: ['pro', 'proCallIllimite'],
      subMenu: ['MONCOMPTE'],
      typeRoute: 'profile',
    },
    {
      title: 'MESINFOS',
      titlePage: 'Mon profil',
      path: '/profileb',
      component: Profile,
      condition: loggedIn,
      onlyFor: ['customer', 'proChildren'],
      typeRoute: 'profile',
    },

    {
      title: 'MONPROFIL1',
      titlePage: 'Mon profil avocat',
      path: '/profile-lawyer',
      component: ProfileLawyer1,
      condition: () => loggedIn() && !isRegisterPending,
      onlyFor: ['lawyer'],
      typeRoute: 'profile',
    },
    {
      title: 'MONPROFIL2',
      titlePage: 'Mon profil avocat 2',
      path: '/profile-lawyer2',
      component: ProfileLawyer2,
      condition: () => loggedIn() && !isRegisterPending,
      onlyFor: ['lawyer'],
      subMenu: ['MONPROFIL1'],
      typeRoute: 'profile',
    },
    {
      title: 'MONPROFIL3',
      titlePage: 'Mon profil avocat 3',
      path: '/profile-lawyer3',
      component: ProfileLawyer3,
      condition: () => loggedIn() && !isRegisterPending,
      onlyFor: ['lawyer'],
      subMenu: ['MONPROFIL1'],
      typeRoute: 'profile',
    },

    {
      title: 'AVAILABILITY',
      titlePage: 'Mon disponibilités',
      path: '/availability-lawyer',
      component: Availability,
      condition: loggedIn,
      onlyFor: ['lawyer'],
      subMenu: ['MONPROFIL1'],
      typeRoute: 'profile',
    },
    {
      title: 'MESEXPERTISES',
      titlePage: 'Mes expertises',
      path: '/expertises-lawyer',
      component: MyExpertise1,
      condition: loggedIn,
      onlyFor: ['lawyer'],
      subMenu: ['MONPROFIL1'],
      typeRoute: 'profile',
    },

    {
      title: 'MONABONNEMENT',
      titlePage: 'Mon abonnement',
      path: '/choose-offers',
      component: () => <ChooseOffers disableRedirection />,
      condition: loggedIn,
      onlyFor: ['customer', 'pro', 'proCallIllimite'],
      typeRoute: 'profile',
    },
    {
      title: 'MESMOYENSDEPAIEMENT1',
      path: '/my-payment-method',
      component: MyPaymentMethod,
      condition: loggedIn,
      onlyFor: ['customer', 'pro', 'proCallIllimite', 'proChildren'],
      typeRoute: 'profile',
    },
    {
      title: 'MYCALLS',
      titlePage: 'Mes calls',
      path: '/calls',
      component: MyCalls,
      condition: loggedIn,
      typeRoute: 'abonnement',
    },

    {
      title: 'MYINVOICES',
      titlePage: 'Mes factures',
      path: '/invoices',
      component: MyInvoices,
      condition: loggedIn,
      onlyFor: ['customer', 'pro', 'proCallIllimite'],
      typeRoute: 'abonnement',
    },

    {
      title: 'MYHISTORY',
      titlePage: 'Mon historique',
      path: '/history',
      component: History,
      condition: loggedIn,
      onlyFor: ['customer', 'pro', 'proCallIllimite', 'lawyer'],
      typeRoute: 'abonnement',
    },
    {
      title: 'Partners',
      titlePage: 'Partenaires',
      path: '/partners',
      component: Partners,
      condition: loggedIn,
      typeRoute: 'profile',
      onlyFor: ['lawyer'],
    },
    {
      title: 'Faqs',
      titlePage: 'Faqs',
      path: '/faqs',
      component: Faqs,
      condition: loggedIn,
      typeRoute: 'profile',
      onlyFor: ['lawyer'],
    },
    {
      title: 'callQuestions',
      path: '/callQuestions',
      component: CallQuestions,
      condition: loggedIn,
      onlyFor: ['customer', 'pro', 'proCallIllimite', 'proChildren'],
    },
    {
      title: 'CallStatus',
      path: '/callStatus',
      component: CallStatus,
      condition: loggedIn,
      onlyFor: ['customer', 'pro', 'proCallIllimite', 'proChildren'],
    },

    {
      title: 'Note',
      path: '/note',
      component: Note,
      condition: loggedIn,
      onlyFor: ['customer', 'pro', 'proCallIllimite', 'proChildren'],
    },
    {
      title: 'NoteLawyer',
      path: '/note-lawyer',
      component: NoteLawyer,
      condition: loggedIn,
      onlyFor: ['lawyer'],
    },
    {
      title: 'MESSOUSCOMPTES',
      titlePage: '',
      path: '/my-sub-account',
      component: MySubAccount,
      condition: loggedIn,
      onlyFor: ['proCallIllimite'],
      subMenu: ['MONCOMPTE', 'MESINFOS'],
      typeRoute: 'profile',
    },
    {
      title: 'NousContacter',
      condition: loggedIn,
      path: '/home-lawyer',
      function: () => mailto('lawyer@callalawyer.fr?subject=[CONTACTER CALL A LAWYER]&body='),
      typeRoute: 'profile',
      displaySubMenu: false,
      onlyFor: ['lawyer'],
    },
    {
      title: 'WebAppDeconnexion',
      path: '/logout',
      condition: loggedIn,
      function: () => logout(),
      redirect: '/',
      typeRoute: 'profile',
      displaySubMenu: false,
    },
    {
      title: 'Users',
      path: '/backoffice/users',
      component: Customers,
      condition: loggedIn && isAdmin,
      extraProps: {
        profileAllUser: true,
      },
      onlyFor: ['customer', 'pro', 'proCallIllimite', 'proChildren', 'lawyer'],
      typeRoute: 'admin',
    },
    {
      title: 'Customers',
      path: '/backoffice/usersPart',
      component: Customers,
      condition: loggedIn && isAdmin,
      subMenu: ['Users'],
      onlyFor: ['customer', 'pro', 'proCallIllimite', 'proChildren', 'lawyer'],
      typeRoute: 'admin',
    },
    {
      title: 'CustomersPro',
      path: '/backoffice/customersPro',
      component: Customers,
      condition: loggedIn && isAdmin,
      extraProps: {
        profilePro: true,
      },
      subMenu: ['Users'],
      onlyFor: ['customer', 'pro', 'proCallIllimite', 'proChildren', 'lawyer'],
      typeRoute: 'admin',
    },
    {
      title: 'Lawyers',
      path: '/backoffice/lawyers',
      component: Customers,
      condition: loggedIn && isAdmin,
      extraProps: {
        lawyer: true,
        profilePro: false,
      },
      subMenu: ['Users'],
      onlyFor: ['customer', 'pro', 'proCallIllimite', 'proChildren', 'lawyer'],
      typeRoute: 'admin',
    },
    {
      title: 'ListInvoices',
      path: '/backoffice/list-invoices',
      component: ListInvoices,
      condition: loggedIn && isAdmin,
      onlyFor: ['customer', 'pro', 'proCallIllimite', 'proChildren', 'lawyer'],
      typeRoute: 'admin',
    },
    {
      title: 'dataBase',
      path: '/backoffice/call',
      component: Calls,
      condition: loggedIn && isAdmin,
      typeRoute: 'admin',
    },
    {
      title: 'Calls',
      path: '/backoffice/call',
      component: Calls,
      condition: loggedIn && isAdmin,
      subMenu: ['dataBase'],
      onlyFor: ['customer', 'pro', 'proCallIllimite', 'proChildren', 'lawyer'],
      typeRoute: 'admin',
    },
    {
      title: 'Categories',
      path: '/backoffice/categories',
      component: Categories,
      condition: loggedIn && isAdmin,
      subMenu: ['dataBase'],
      onlyFor: ['customer', 'pro', 'proCallIllimite', 'proChildren', 'lawyer'],
      typeRoute: 'admin',
    },
    {
      title: 'KeywordNotFound',
      path: '/backoffice/keywordNotFound',
      component: KeywordNotFound,
      condition: loggedIn && isAdmin,
      subMenu: ['dataBase'],
      onlyFor: ['customer', 'pro', 'proCallIllimite', 'proChildren', 'lawyer'],
      typeRoute: 'admin',
    },
    {
      title: 'Barreaux',
      path: '/backoffice/barreaux',
      component: Barreaux,
      condition: loggedIn && isAdmin,
      subMenu: ['dataBase'],
      onlyFor: ['customer', 'pro', 'proCallIllimite', 'proChildren', 'lawyer'],
      typeRoute: 'admin',
    },
    {
      title: 'Languages',
      path: '/backoffice/languages',
      component: Languages,
      condition: loggedIn && isAdmin,
      subMenu: ['dataBase'],
      onlyFor: ['customer', 'pro', 'proCallIllimite', 'proChildren', 'lawyer'],
      typeRoute: 'admin',
    },
    {
      title: 'Competences',
      path: '/backoffice/competences',
      component: Competences,
      condition: loggedIn && isAdmin,
      subMenu: ['dataBase'],
      onlyFor: ['customer', 'pro', 'proCallIllimite', 'proChildren', 'lawyer'],
      typeRoute: 'admin',
    },
    {
      title: 'CustomerTypes',
      path: '/backoffice/customerTypes',
      component: CustomerTypes,
      condition: loggedIn && isAdmin,
      subMenu: ['dataBase'],
      onlyFor: ['customer', 'pro', 'proCallIllimite', 'proChildren', 'lawyer'],
      typeRoute: 'admin',
    },
    {
      title: 'Mails',
      path: '/backoffice/mails',
      component: Mails,
      condition: loggedIn && isAdmin,
      subMenu: ['dataBase'],
      onlyFor: ['customer', 'pro', 'proCallIllimite', 'proChildren', 'lawyer'],
      typeRoute: 'admin',
    },
    {
      title: 'Faqs',
      path: '/backoffice/faqs',
      component: AdminFaq,
      condition: loggedIn && isAdmin,
      subMenu: ['dataBase'],
      onlyFor: ['customer', 'pro', 'proCallIllimite', 'proChildren', 'lawyer'],
      typeRoute: 'admin',
    },
    {
      title: 'Partners',
      path: '/backoffice/partners',
      component: AdminPartner,
      condition: loggedIn && isAdmin,
      subMenu: ['dataBase'],
      onlyFor: ['customer', 'pro', 'proCallIllimite', 'proChildren', 'lawyer'],
      typeRoute: 'admin',
    },
    {
      title: 'Suggestions',
      path: '/backoffice/suggestions',
      component: Suggestions,
      condition: loggedIn && isAdmin,
      subMenu: ['dataBase'],
      onlyFor: ['customer', 'pro', 'proCallIllimite', 'proChildren', 'lawyer'],
      typeRoute: 'admin',
    },
    {
      title: 'Partenariat',
      path: '/backoffice/partenariat',
      component: CallPartner,
      condition: loggedIn && isAdmin,
      subMenu: ['dataBase'],
      onlyFor: ['customer', 'pro', 'proCallIllimite', 'proChildren', 'lawyer'],
      typeRoute: 'admin',
      superAdmin: true,
    },
    {
      title: 'Settings',
      path: '/backoffice/settings',
      component: Settings,
      condition: loggedIn && isAdmin,
      subMenu: ['dataBase'],
      onlyFor: ['customer', 'pro', 'proCallIllimite', 'proChildren', 'lawyer'],
      typeRoute: 'admin',
      superAdmin: true,
    },
    {
      title: 'Call',
      path: '/call/:lawyerId/:step/:substep?',
      component: CallStepper,
    },
  ]
}

export default getRoutes
